import { createAPIRequest, createAPIResponse, ListResponse } from '@tlx/astro-shared';
import { APIUrls } from '@Util/urls';
import useSWR from 'swr';

export type SalarySettingsHolidayDTO = {
    id: number;
    days: number;
    vacationPayPercentage1: number;
    vacationPayPercentage2: number;
};

export function useLatestHoliday() {
    const { data, error, isLoading } = useSWR<ListResponse<SalarySettingsHolidayDTO>>(getSalaryHolidayURL(), {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    return { data: data?.values[data.values.length - 1], error, isLoading };
}

function getSalaryHolidayURL({ id }: { id?: number } = {}) {
    const defaultFields = ['id', 'days', 'vacationPayPercentage1', 'vacationPayPercentage2'];
    const params = new URLSearchParams();
    params.set('fields', [...defaultFields].sort().join(','));

    return `${APIUrls.SALARY_SETTINGS_HOLIDAY}/${id ?? ''}?${params.toString()}`;
}

export async function updateHolidaySettings(id: number, dto: Partial<SalarySettingsHolidayDTO>) {
    const request = createAPIRequest(getSalaryHolidayURL({ id }), {
        method: 'PUT',
        body: JSON.stringify(dto),
        headers: {
            'content-type': 'application/json; charset=utf-8',
        },
    });
    const response = await window.fetch(request);
    return await createAPIResponse(request, response);
}
